"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
exports.default = new Network_1.default('kaia', [
    new Token_1.default('kaia', 'KAIA', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} KAIA', 'icon/kaia.svg'),
    new Token_1.default('oether', 'oETH', 'bifi', 1, '0x34d21b1e550d73cee41151c77f3c73359527a396', '', false, true, false, [], '{} oETH', 'icon/oeth.svg'),
    new Token_1.default('ousdt', 'oUSDT', 'bifi', 2, '0xcee8faf64bb97a73bb51e115aa89c17ffa8dd167', '', false, true, false, [], '{} oUSDT', 'icon/ousdt.svg'),
    new Token_1.default('kdai', 'kDAI', 'bifi', 3, '0x5c74070fdea071359b86082bd9f9b3deaafbe32b', '', false, true, false, [], '{} kDAI', 'icon/kdai.png'),
    new Token_1.default('ousdc', 'oUSDC', 'bifi', 4, '0x754288077d0ff82af7a5317c7cb8c444d421d103', '', false, true, false, [], '{} oUSDC', 'icon/ousdc.png'),
    new Token_1.default('owbtc', 'oWBTC', 'bifi', 5, '0x16d0e1fbd024c600ca0380a4c5d57ee7a2ecbf9c', '', false, true, false, [], '{} oWBTC', 'icon/owbtc.svg'),
    new Token_1.default('oxrp', 'oXRP', 'bifi', 6, '0x9eaefb09fe4aabfbe6b1ca316a3c36afc83a393f', '', false, true, false, [], '{} oXRP', 'icon/oxrp.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0xf6c2ecd4b14dab46246608e8e1c2b697faebea11', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'kaia'),
    new Handler_1.default(1, 'oether'),
    new Handler_1.default(2, 'ousdt'),
    new Handler_1.default(3, 'kdai'),
    new Handler_1.default(4, 'ousdc'),
    new Handler_1.default(5, 'owbtc'),
    new Handler_1.default(6, 'oxrp')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('bifi.getOraclePeriodDelta', 'callProxyOracle_getPeriodDelta()', [], [
        '(uint256,uint256,uint256,int256,bool)[]',
        'bool'
    ]),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionNFT(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x5F7c8011f708F6b6Db391d399A0345c1e202f6B4'),
    new EntryPoint_1.default('xBifi', '0x5B18dA521B129263B57d4226F9be6E5E094f6004'),
    new EntryPoint_1.default('xBifi.factory', '0x6A99e39B6a726ED3467082F4dc30B9cd31A63032')
], 3000);
//# sourceMappingURL=kaia.js.map